
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "documents-public-ui",
  currentProjectVersion: "static-1.35615",
  depVersions: {
  "documents-public-ui": "static-1.35615",
  "atom": "static-1.5582",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2997",
  "client-types": "static-1.512",
  "cssUtils": "static-1.1132",
  "customer-data-filters-ui": "static-1.41463",
  "customer-data-objects": "static-1.8221",
  "customer-data-property-utils": "static-1.8563",
  "documents-lib": "static-1.35620",
  "emoji-mart": "static-3.9",
  "flux-actions": "static-1.383",
  "FormsCommonComponents": "static-1.86891",
  "FormUrlGenerator": "static-2.5221",
  "foundations-theming-specialty": "static-1.2717",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5330",
  "highcharts": "static-8.117",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6098",
  "hs-test-utils": "static-1.8549",
  "hub-http": "static-1.6712",
  "hubspot-dlb": "static-2.1911",
  "HubStyle": "static-2.12305",
  "HubStyleTokens": "static-2.11998",
  "I18n": "static-7.1717",
  "icons": "static-2.710",
  "jasmine-immutable": "static-1.3447",
  "jasmine-runner": "static-1.6963",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7657",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3390",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5887",
  "quartz": "static-1.7700",
  "react": "static-7.204",
  "react-dlb": "static-1.96",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17245",
  "react-select-plus": "static-1.120",
  "react-utils": "static-2.5684",
  "react-virtualized": "static-2.114",
  "reference-resolvers": "static-1.8694",
  "reference-resolvers-lite": "static-1.8621",
  "reporting-data": "static-1.69507",
  "reporting-reports": "static-1.69183",
  "reporting-snowflake": "static-1.58123",
  "reporting-testing-lib": "static-1.11440",
  "reporting-visualizations": "static-1.61581",
  "reselect": "static-3.18",
  "sales-content-partitioning": "static-1.9469",
  "sanitize": "static-1.4976",
  "sanitize-text": "static-1.8668",
  "SharedI18nStrings": "static-1.190",
  "SharedLegalStrings": "static-1.2234",
  "signup-constants": "static-1.20019",
  "signup-ui-url-generator": "static-2.8544",
  "StyleGuideUI": "static-3.520",
  "superstore": "static-1.5264",
  "tinymce": "static-6.5",
  "transmute": "static-2.97",
  "ui-addon-draggable": "static-3.5261",
  "ui-addon-form-validation": "static-1.11352",
  "ui-asset-management-lib": "static-1.11613",
  "ui-images": "static-2.1285",
  "UIComponents": "static-3.8944",
  "usage-tracker": "static-1.7828",
  "usage-tracker-container": "static-1.7818",
  "usage-tracker-core": "static-1.7678",
  "viral-links-lib": "static-1.7589",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.10147",
  "foundations-components": "static-1.8802",
  "immutable": "static-2.88",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.458",
  "quartz-config": "static-1.1478",
  "quartz-core": "static-1.6919",
  "quick-fetch": "static-1.4249",
  "raven": "static-3.6411",
  "redux": "static-4.81",
  "redux-thunk": "static-2.86",
  "rpc-client-utils": "static-1.5172",
  "ui-addon-i18n": "static-1.11655",
  "ui-addon-upgrades": "static-9.18570",
  "enviro": "static-4.523",
  "hs-promise-rejection-tracking": "static-1.6078",
  "raven-hubspot": "static-1.6718",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4383",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3977",
  "quartz-webpack": "static-1.3924",
  "foundations-assets": "static-1.5397",
  "foundations-theming": "static-1.5001",
  "hub-http-janus": "static-1.914",
  "hub-http-shared-msw-handlers": "static-1.10958",
  "hubspotter-http": "static-1.4993",
  "trellis-components": "static-1.3199",
  "trellis-migration-context": "static-1.88",
  "sassPrefix": "static-1.393",
  "conversations-skeleton-state": "static-1.7624",
  "crm-message-bus": "static-1.44174",
  "customer-data-filters-ui-msw-helpers": "static-1.23898",
  "customer-data-objects-ui-components": "static-1.13542",
  "customer-data-reference-ui-components": "static-1.13681",
  "customer-data-ui-utilities": "static-1.10342",
  "events-data-lib": "static-1.757",
  "framework-builder-read-service-client": "static-1.4354",
  "hs-resources": "static-1.696",
  "immer": "static-1.107",
  "inbound-db-meta-service-client": "static-1.3793",
  "inbound-db-properties-service-client": "static-1.4170",
  "multi-account-reference-resolvers": "static-1.1524",
  "onboarding-tours": "static-1.17439",
  "pulse": "static-1.1163",
  "reporting-datasets-permissions-lib": "static-1.14824",
  "segments-client-types": "static-1.12296",
  "stylex": "static-1.48",
  "trellis-assets": "static-1.3180",
  "trellis-theming": "static-1.1530",
  "ui-addon-teams": "static-1.22046",
  "quartz-auth": "static-1.1375",
  "ui-business-units-lib": "static-1.9604",
  "usage-tracker-session-replay": "static-1.5514",
  "ai-components-ui-library": "static-1.10078",
  "ContentUtils": "static-1.69554",
  "customer-data-properties": "static-1.53169",
  "forms-ai-lib": "static-1.5027",
  "forms-utils-lib": "static-1.13387",
  "foundations-components-test-utils": "static-1.6285",
  "react-dnd-compat": "static-1.5114",
  "react-tinymce": "static-1.56329",
  "tinymce-config": "static-2.55455",
  "ui-gdpr-components": "static-1.10658",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3986",
  "HeadJS": "static-2.830",
  "framer-motion": "static-1.86",
  "hs-test-utils-bend-plugin": "static-1.3660",
  "msw": "static-1.105",
  "msw-config": "static-1.36",
  "testing-library": "static-1.167",
  "hs-locale-management": "static-1.421",
  "ui-fonts": "static-1.1260",
  "i18n-data": "static-1.237",
  "moment-timezone": "static-5.98",
  "jasmine": "static-4.4812",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.209",
  "quartz-head": "static-1.1365",
  "web-vitals": "static-1.21",
  "batch-promise": "static-1.2060",
  "external-options-client-types": "static-1.4457",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.1375",
  "frontend-preferences-client": "static-1.8429",
  "graphql": "static-1.95",
  "persist-promise": "static-1.4217",
  "reporting-client-types": "static-1.2869",
  "apollo-stack-hubspot": "static-3.101",
  "hubspot-apollo-client": "static-1.5389",
  "foundations-components-legacy": "static-1.1827",
  "quartz-routing": "static-1.1130",
  "hs-story-utils": "static-1.9938",
  "react-flip-move": "static-1.85",
  "nested-table": "static-1.733",
  "seat-types-lib": "static-1.1106",
  "timezone-utils": "static-2.5736",
  "react-create-root-preference": "static-1.113",
  "bend-plugin-foundations-components": "static-1.5071",
  "floating-ui": "static-1.70",
  "react-aria": "static-1.79",
  "tanstack-table": "static-1.68",
  "opentelemetry-fe-types": "static-1.302",
  "dispatcher": "static-1.150",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.612",
  "module-federation": "static-1.42",
  "opentelemetry-fe": "static-1.677",
  "quartz-test": "static-1.1375",
  "quartz-tracking": "static-1.1079",
  "bend-plugin-chirp-manifest": "static-1.582",
  "chirp-fetch": "static-1.2411",
  "merchandise-lib": "static-1.288",
  "purchase-motions-components": "static-1.6676",
  "ts-schema": "static-1.4413",
  "bender-build-tools": "static-1.3622",
  "bend-plugin-foundations-theming": "static-1.3484",
  "base-ui": "static-1.31",
  "react-day-picker": "static-1.17",
  "tanstack-virtual": "static-1.45",
  "restore-request-side-panel-lib": "static-1.2108",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.5099",
  "conditional-properties-service-client": "static-1.4132",
  "crm-pipelines-api-client-types": "static-1.4462",
  "event-emitter": "static-1.1467",
  "fdsr-migration-layer": "static-1.523",
  "multi-currency-client-types": "static-1.4027",
  "getting-started-shared-tasks": "static-1.19622",
  "growth-data-modal": "static-1.6178",
  "growth-onboarding-confetti": "static-1.3568",
  "growth-onboarding-next-action-utils": "static-1.3043",
  "navigation-components": "static-1.19234",
  "nest": "static-1.744",
  "onboarding-tours-client": "static-1.5654",
  "onboarding-tours-utils": "static-1.1506",
  "ui-shepherd-react": "static-3.10792",
  "ui-shepherd-tracker": "static-1.8173",
  "ui-universal-auth": "static-1.9807",
  "user-context": "static-1.5565",
  "bend-plugin-pulse": "static-1.666",
  "fast-json-patch": "static-1.76",
  "crm-index-associations-lib": "static-1.6959",
  "stylex-utils": "static-1.184",
  "hubspotter-http-shared-msw-handlers": "static-1.10956",
  "magpie-lib": "static-1.5935",
  "navigation-messaging": "static-1.8561",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.24085",
  "copilot-toolkit": "static-1.12213",
  "cms-field-types": "static-1.5321",
  "content-icons-ui": "static-1.2491",
  "integrations-lib": "static-1.17499",
  "calling-global-api": "static-1.66316",
  "calling-internal-common": "static-1.31831",
  "calling-lifecycle-internal": "static-1.67698",
  "calling-lifecycle-messages": "static-1.59990",
  "commerce-products-lib": "static-1.10997",
  "crm-index-visualization-core": "static-1.4803",
  "crm-links": "static-1.6823",
  "customer-data-properties-shared-msw-handlers": "static-1.10285",
  "data-agent-utils": "static-1.984",
  "data-token-picker": "static-1.17186",
  "file-manager-components": "static-1.24892",
  "formula-editor": "static-1.15053",
  "google-libphonenumber": "static-1.52",
  "inbounddb-objects-service-types": "static-1.4533",
  "meetings-icalendar-utils-lib": "static-1.1142",
  "object-builder-ui-client": "static-1.50122",
  "pipeline-validation-client-types": "static-1.4302",
  "property-value-citations": "static-1.3783",
  "react-colorpicker": "static-2.10715",
  "rich-text-lib": "static-1.20606",
  "smart-data-capture-core": "static-1.549",
  "tiered-pricing": "static-1.2338",
  "tinymce-plugins": "static-1.58569",
  "tinymce-themes": "static-1.57425",
  "topics-actions-lib": "static-1.695",
  "trellis-ext-i18n": "static-1.1435",
  "trial-components-library": "static-1.14438",
  "ui-addon-emoji-picker": "static-1.10373",
  "ui-addon-iframeable": "static-1.9587",
  "zustand": "static-1.92",
  "final-form": "static-1.85",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.84",
  "hub-http-contrib": "static-1.3538",
  "interframe": "static-3.5249",
  "tinymce-data": "static-1.41540",
  "ui-addon-sales-email": "static-1.5713",
  "hubspot-apollo-cache": "static-1.848",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.662",
  "opentelemetry-web": "static-1.25",
  "onboarding-scopes": "static-1.6959",
  "purchase-motions-api": "static-1.6679",
  "onboarding-data-sync-lib": "static-1.2885",
  "growth-onboarding-next-action-components": "static-1.3071",
  "user-context-client": "static-1.5019",
  "idb-keyval": "static-1.57",
  "magpie-types": "static-1.5395",
  "reactive-lib": "static-1.1230",
  "simple-logging-lib": "static-1.3557",
  "custom-vendor-connection-lib": "static-1.371",
  "unified-auth-core-lib": "static-1.1603",
  "getting-started-shared-tasks-store": "static-1.18740",
  "nav-meta": "static-1.30871",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.2288",
  "integrations-error-boundary-lib": "static-1.14914",
  "integrations-tracking-lib": "static-1.6134",
  "native-integrations-shared-strings": "static-1.8268",
  "redux-observable": "static-1.81",
  "ReduxMessenger": "static-2.10880",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31838",
  "shared-worker-versioning": "static-1.11550",
  "calling-usage-tracker": "static-1.7051",
  "customer-data-tracking": "static-1.7378",
  "voice-sms-access-library": "static-1.2557",
  "commerce-permissions": "static-1.1293",
  "growth-payments-core": "static-1.26562",
  "products-iframe-lib": "static-1.8976",
  "products-ui-components-shared-msw-handlers": "static-1.11340",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.11041",
  "sales-views-client-types": "static-1.4768",
  "framework-data-schema-resolvers": "static-1.7404",
  "location-customization-utils-lib": "static-1.10488",
  "data-agent-kit": "static-1.971",
  "enrichment-settings-lib": "static-1.328",
  "fsm": "static-1.4268",
  "policy-lib": "static-1.7312",
  "apollo-dlb": "static-3.98",
  "immerable": "static-1.4649",
  "poll-commands": "static-1.3983",
  "video-components-external": "static-1.12502",
  "video-data-lib": "static-1.36160",
  "bark-lib": "static-1.17041",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.108",
  "crm-properties-common-lib": "static-1.6405",
  "react-codemirror": "static-1.11150",
  "FileManagerLib": "static-1.40532",
  "content-assistance-lib": "static-1.8469",
  "FileManagerCore": "static-1.40391",
  "layout-dnd-components": "static-1.13276",
  "layout-dnd-utils": "static-1.12251",
  "ui-brand-identity-lib": "static-1.17023",
  "NamespacedHubStyle": "static-2.9386",
  "embedded-academy-lib": "static-1.16111",
  "hubs-service-types": "static-1.1773",
  "nudge-client-utils": "static-1.3471",
  "salesImages": "static-1.766",
  "InboxConnectUtils": "static-4.15900",
  "meetings-connect-utils-lib": "static-1.8126",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1266",
  "breeze-engine-core": "static-1.1566",
  "highlight.js": "static-1.92",
  "universal-page-editor-lib": "static-1.3524",
  "calling-orchestration-schema": "static-1.37334",
  "ui-addon-opt": "static-4.8930",
  "framework-data-schema-quick-fetch": "static-1.7309",
  "crm-record-cards-service-types": "static-1.3880",
  "trellis-story-utils": "static-1.5005",
  "storybook-react": "static-1.46",
  "content-media-composition-data-lib": "static-1.13650",
  "content-media-compositions": "static-2.17657",
  "media-bridge-lib": "static-1.19690",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16723",
  "browser-eslint": "static-2.57",
  "audio-components": "static-1.6615",
  "FileManagerImages": "static-1.38043",
  "video-components": "static-1.14504",
  "ui-addon-video-player": "static-1.9129",
  "ui-coaching-tips": "static-1.29615",
  "breeze-artifacts-sdk": "static-1.1095",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.30108",
  "html-to-image": "static-1.67",
  "urlinator": "static-1.5024",
  "video-embed": "static-1.36994",
  "ContentData": "static-1.69629",
  "layout-data-lib": "static-1.10576",
  "academy-common-lib": "static-1.15572",
  "nudge-custom-function-registry": "static-1.3228",
  "nudge-renderer-utils": "static-1.3547",
  "whisper-core-api": "static-1.7686",
  "crm-record-cards-client": "static-1.143",
  "social-insights-client-types": "static-1.22985",
  "growth-onboarding-feedback-components": "static-1.7091",
  "outpost": "static-1.4640",
  "advanced-menus-core": "static-1.15869",
  "advanced-menus-lib": "static-1.12609",
  "ExportDialog": "static-6.10882",
  "ui-memberships-settings-lib": "static-1.35268",
  "academy-service-client": "static-1.4202",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4905",
  "trellis-ecosystem": "static-1.7901",
  "ui-addon-react-router-dom": "static-1.10035",
  "wootric-nps": "static-1.7316",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15868",
  "simple-menus-lib": "static-1.17385",
  "settings-ui-lib": "static-1.13038",
  "marketplace-ui-apps-core": "static-1.19633",
  "marketplace-ui-common": "static-1.21101",
  "developer-experience-shared-components": "static-1.11051",
  "immutable-less": "static-1.5161",
  "marketplace-ui-client-types": "static-1.18508",
  "ui-addon-integrations-directory-panel": "static-2.8460",
  "ui-extensibility-client-types": "static-1.4425",
  "ai-settings-ui-library": "static-1.8639",
  "ui-product-approvals-common": "static-1.1710",
  "apps-service-types": "static-1.4117",
  "oauth-service-types": "static-1.4646",
  "simple-data-table": "static-1.3880"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35615",
  "atom": "/atom/static-1.5582",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2997",
  "client-types": "/client-types/static-1.512",
  "cssUtils": "/cssUtils/static-1.1132",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41463",
  "customer-data-objects": "/customer-data-objects/static-1.8221",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8563",
  "documents-lib": "/documents-lib/static-1.35620",
  "emoji-mart": "/emoji-mart/static-3.9",
  "flux-actions": "/flux-actions/static-1.383",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86891",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5221",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2717",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5330",
  "highcharts": "/highcharts/static-8.117",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6098",
  "hs-test-utils": "/hs-test-utils/static-1.8549",
  "hub-http": "/hub-http/static-1.6712",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyle": "/HubStyle/static-2.12305",
  "HubStyleTokens": "/HubStyleTokens/static-2.11998",
  "I18n": "/I18n/static-7.1717",
  "icons": "/icons/static-2.710",
  "jasmine-immutable": "/jasmine-immutable/static-1.3447",
  "jasmine-runner": "/jasmine-runner/static-1.6963",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7657",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3390",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5887",
  "quartz": "/quartz/static-1.7700",
  "react": "/react/static-7.204",
  "react-dlb": "/react-dlb/static-1.96",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17245",
  "react-select-plus": "/react-select-plus/static-1.120",
  "react-utils": "/react-utils/static-2.5684",
  "react-virtualized": "/react-virtualized/static-2.114",
  "reference-resolvers": "/reference-resolvers/static-1.8694",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8621",
  "reporting-data": "/reporting-data/static-1.69507",
  "reporting-reports": "/reporting-reports/static-1.69183",
  "reporting-snowflake": "/reporting-snowflake/static-1.58123",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11440",
  "reporting-visualizations": "/reporting-visualizations/static-1.61581",
  "reselect": "/reselect/static-3.18",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9469",
  "sanitize": "/sanitize/static-1.4976",
  "sanitize-text": "/sanitize-text/static-1.8668",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.190",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2234",
  "signup-constants": "/signup-constants/static-1.20019",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8544",
  "StyleGuideUI": "/StyleGuideUI/static-3.520",
  "superstore": "/superstore/static-1.5264",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.97",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5261",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11352",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11613",
  "ui-images": "/ui-images/static-2.1285",
  "UIComponents": "/UIComponents/static-3.8944",
  "usage-tracker": "/usage-tracker/static-1.7828",
  "usage-tracker-container": "/usage-tracker-container/static-1.7818",
  "usage-tracker-core": "/usage-tracker-core/static-1.7678",
  "viral-links-lib": "/viral-links-lib/static-1.7589",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.10147",
  "foundations-components": "/foundations-components/static-1.8802",
  "immutable": "/immutable/static-2.88",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.458",
  "quartz-config": "/quartz-config/static-1.1478",
  "quartz-core": "/quartz-core/static-1.6919",
  "quick-fetch": "/quick-fetch/static-1.4249",
  "raven": "/raven/static-3.6411",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.86",
  "rpc-client-utils": "/rpc-client-utils/static-1.5172",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11655",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18570",
  "enviro": "/enviro/static-4.523",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.6078",
  "raven-hubspot": "/raven-hubspot/static-1.6718",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3977",
  "quartz-webpack": "/quartz-webpack/static-1.3924",
  "foundations-assets": "/foundations-assets/static-1.5397",
  "foundations-theming": "/foundations-theming/static-1.5001",
  "hub-http-janus": "/hub-http-janus/static-1.914",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10958",
  "hubspotter-http": "/hubspotter-http/static-1.4993",
  "trellis-components": "/trellis-components/static-1.3199",
  "trellis-migration-context": "/trellis-migration-context/static-1.88",
  "sassPrefix": "/sassPrefix/static-1.393",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7624",
  "crm-message-bus": "/crm-message-bus/static-1.44174",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23898",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13542",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13681",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10342",
  "events-data-lib": "/events-data-lib/static-1.757",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4354",
  "hs-resources": "/hs-resources/static-1.696",
  "immer": "/immer/static-1.107",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3793",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4170",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1524",
  "onboarding-tours": "/onboarding-tours/static-1.17439",
  "pulse": "/pulse/static-1.1163",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14824",
  "segments-client-types": "/segments-client-types/static-1.12296",
  "stylex": "/stylex/static-1.48",
  "trellis-assets": "/trellis-assets/static-1.3180",
  "trellis-theming": "/trellis-theming/static-1.1530",
  "ui-addon-teams": "/ui-addon-teams/static-1.22046",
  "quartz-auth": "/quartz-auth/static-1.1375",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9604",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5514",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10078",
  "ContentUtils": "/ContentUtils/static-1.69554",
  "customer-data-properties": "/customer-data-properties/static-1.53169",
  "forms-ai-lib": "/forms-ai-lib/static-1.5027",
  "forms-utils-lib": "/forms-utils-lib/static-1.13387",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6285",
  "react-dnd-compat": "/react-dnd-compat/static-1.5114",
  "react-tinymce": "/react-tinymce/static-1.56329",
  "tinymce-config": "/tinymce-config/static-2.55455",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10658",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3986",
  "HeadJS": "/HeadJS/static-2.830",
  "framer-motion": "/framer-motion/static-1.86",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3660",
  "msw": "/msw/static-1.105",
  "msw-config": "/msw-config/static-1.36",
  "testing-library": "/testing-library/static-1.167",
  "hs-locale-management": "/hs-locale-management/static-1.421",
  "ui-fonts": "/ui-fonts/static-1.1260",
  "i18n-data": "/i18n-data/static-1.237",
  "moment-timezone": "/moment-timezone/static-5.98",
  "jasmine": "/jasmine/static-4.4812",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.209",
  "quartz-head": "/quartz-head/static-1.1365",
  "web-vitals": "/web-vitals/static-1.21",
  "batch-promise": "/batch-promise/static-1.2060",
  "external-options-client-types": "/external-options-client-types/static-1.4457",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.1375",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8429",
  "graphql": "/graphql/static-1.95",
  "persist-promise": "/persist-promise/static-1.4217",
  "reporting-client-types": "/reporting-client-types/static-1.2869",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.101",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5389",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1827",
  "quartz-routing": "/quartz-routing/static-1.1130",
  "hs-story-utils": "/hs-story-utils/static-1.9938",
  "react-flip-move": "/react-flip-move/static-1.85",
  "nested-table": "/nested-table/static-1.733",
  "seat-types-lib": "/seat-types-lib/static-1.1106",
  "timezone-utils": "/timezone-utils/static-2.5736",
  "react-create-root-preference": "/react-create-root-preference/static-1.113",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5071",
  "floating-ui": "/floating-ui/static-1.70",
  "react-aria": "/react-aria/static-1.79",
  "tanstack-table": "/tanstack-table/static-1.68",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.302",
  "dispatcher": "/dispatcher/static-1.150",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.612",
  "module-federation": "/module-federation/static-1.42",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.677",
  "quartz-test": "/quartz-test/static-1.1375",
  "quartz-tracking": "/quartz-tracking/static-1.1079",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.582",
  "chirp-fetch": "/chirp-fetch/static-1.2411",
  "merchandise-lib": "/merchandise-lib/static-1.288",
  "purchase-motions-components": "/purchase-motions-components/static-1.6676",
  "ts-schema": "/ts-schema/static-1.4413",
  "bender-build-tools": "/bender-build-tools/static-1.3622",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3484",
  "base-ui": "/base-ui/static-1.31",
  "react-day-picker": "/react-day-picker/static-1.17",
  "tanstack-virtual": "/tanstack-virtual/static-1.45",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2108",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5099",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4132",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4462",
  "event-emitter": "/event-emitter/static-1.1467",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.523",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4027",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19622",
  "growth-data-modal": "/growth-data-modal/static-1.6178",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3568",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3043",
  "navigation-components": "/navigation-components/static-1.19234",
  "nest": "/nest/static-1.744",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5654",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1506",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10792",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8173",
  "ui-universal-auth": "/ui-universal-auth/static-1.9807",
  "user-context": "/user-context/static-1.5565",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.666",
  "fast-json-patch": "/fast-json-patch/static-1.76",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6959",
  "stylex-utils": "/stylex-utils/static-1.184",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10956",
  "magpie-lib": "/magpie-lib/static-1.5935",
  "navigation-messaging": "/navigation-messaging/static-1.8561",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.24085",
  "copilot-toolkit": "/copilot-toolkit/static-1.12213",
  "cms-field-types": "/cms-field-types/static-1.5321",
  "content-icons-ui": "/content-icons-ui/static-1.2491",
  "integrations-lib": "/integrations-lib/static-1.17499",
  "calling-global-api": "/calling-global-api/static-1.66316",
  "calling-internal-common": "/calling-internal-common/static-1.31831",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67698",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59990",
  "commerce-products-lib": "/commerce-products-lib/static-1.10997",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4803",
  "crm-links": "/crm-links/static-1.6823",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10285",
  "data-agent-utils": "/data-agent-utils/static-1.984",
  "data-token-picker": "/data-token-picker/static-1.17186",
  "file-manager-components": "/file-manager-components/static-1.24892",
  "formula-editor": "/formula-editor/static-1.15053",
  "google-libphonenumber": "/google-libphonenumber/static-1.52",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4533",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1142",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50122",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4302",
  "property-value-citations": "/property-value-citations/static-1.3783",
  "react-colorpicker": "/react-colorpicker/static-2.10715",
  "rich-text-lib": "/rich-text-lib/static-1.20606",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.549",
  "tiered-pricing": "/tiered-pricing/static-1.2338",
  "tinymce-plugins": "/tinymce-plugins/static-1.58569",
  "tinymce-themes": "/tinymce-themes/static-1.57425",
  "topics-actions-lib": "/topics-actions-lib/static-1.695",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1435",
  "trial-components-library": "/trial-components-library/static-1.14438",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10373",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9587",
  "zustand": "/zustand/static-1.92",
  "final-form": "/final-form/static-1.85",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.84",
  "hub-http-contrib": "/hub-http-contrib/static-1.3538",
  "interframe": "/interframe/static-3.5249",
  "tinymce-data": "/tinymce-data/static-1.41540",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5713",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.848",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.662",
  "opentelemetry-web": "/opentelemetry-web/static-1.25",
  "onboarding-scopes": "/onboarding-scopes/static-1.6959",
  "purchase-motions-api": "/purchase-motions-api/static-1.6679",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2885",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3071",
  "user-context-client": "/user-context-client/static-1.5019",
  "idb-keyval": "/idb-keyval/static-1.57",
  "magpie-types": "/magpie-types/static-1.5395",
  "reactive-lib": "/reactive-lib/static-1.1230",
  "simple-logging-lib": "/simple-logging-lib/static-1.3557",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.371",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1603",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18740",
  "nav-meta": "/nav-meta/static-1.30871",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2288",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14914",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6134",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8268",
  "redux-observable": "/redux-observable/static-1.81",
  "ReduxMessenger": "/ReduxMessenger/static-2.10880",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31838",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11550",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7051",
  "customer-data-tracking": "/customer-data-tracking/static-1.7378",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2557",
  "commerce-permissions": "/commerce-permissions/static-1.1293",
  "growth-payments-core": "/growth-payments-core/static-1.26562",
  "products-iframe-lib": "/products-iframe-lib/static-1.8976",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11340",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.11041",
  "sales-views-client-types": "/sales-views-client-types/static-1.4768",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7404",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10488",
  "data-agent-kit": "/data-agent-kit/static-1.971",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.328",
  "fsm": "/fsm/static-1.4268",
  "policy-lib": "/policy-lib/static-1.7312",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "immerable": "/immerable/static-1.4649",
  "poll-commands": "/poll-commands/static-1.3983",
  "video-components-external": "/video-components-external/static-1.12502",
  "video-data-lib": "/video-data-lib/static-1.36160",
  "bark-lib": "/bark-lib/static-1.17041",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.108",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6405",
  "react-codemirror": "/react-codemirror/static-1.11150",
  "FileManagerLib": "/FileManagerLib/static-1.40532",
  "content-assistance-lib": "/content-assistance-lib/static-1.8469",
  "FileManagerCore": "/FileManagerCore/static-1.40391",
  "layout-dnd-components": "/layout-dnd-components/static-1.13276",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12251",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.17023",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9386",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16111",
  "hubs-service-types": "/hubs-service-types/static-1.1773",
  "nudge-client-utils": "/nudge-client-utils/static-1.3471",
  "salesImages": "/salesImages/static-1.766",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15900",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8126",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1266",
  "breeze-engine-core": "/breeze-engine-core/static-1.1566",
  "highlight.js": "/highlight.js/static-1.92",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3524",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37334",
  "ui-addon-opt": "/ui-addon-opt/static-4.8930",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7309",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3880",
  "trellis-story-utils": "/trellis-story-utils/static-1.5005",
  "storybook-react": "/storybook-react/static-1.46",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13650",
  "content-media-compositions": "/content-media-compositions/static-2.17657",
  "media-bridge-lib": "/media-bridge-lib/static-1.19690",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16723",
  "browser-eslint": "/browser-eslint/static-2.57",
  "audio-components": "/audio-components/static-1.6615",
  "FileManagerImages": "/FileManagerImages/static-1.38043",
  "video-components": "/video-components/static-1.14504",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9129",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29615",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1095",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.30108",
  "html-to-image": "/html-to-image/static-1.67",
  "urlinator": "/urlinator/static-1.5024",
  "video-embed": "/video-embed/static-1.36994",
  "ContentData": "/ContentData/static-1.69629",
  "layout-data-lib": "/layout-data-lib/static-1.10576",
  "academy-common-lib": "/academy-common-lib/static-1.15572",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3228",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3547",
  "whisper-core-api": "/whisper-core-api/static-1.7686",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.143",
  "social-insights-client-types": "/social-insights-client-types/static-1.22985",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7091",
  "outpost": "/outpost/static-1.4640",
  "advanced-menus-core": "/advanced-menus-core/static-1.15869",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12609",
  "ExportDialog": "/ExportDialog/static-6.10882",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35268",
  "academy-service-client": "/academy-service-client/static-1.4202",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4905",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7901",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10035",
  "wootric-nps": "/wootric-nps/static-1.7316",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15868",
  "simple-menus-lib": "/simple-menus-lib/static-1.17385",
  "settings-ui-lib": "/settings-ui-lib/static-1.13038",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19633",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21101",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11051",
  "immutable-less": "/immutable-less/static-1.5161",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18508",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8460",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4425",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8639",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1710",
  "apps-service-types": "/apps-service-types/static-1.4117",
  "oauth-service-types": "/oauth-service-types/static-1.4646",
  "simple-data-table": "/simple-data-table/static-1.3880"
}
};
